import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

import Icon from "../Icon";

import * as staggeredTilesStyles from "./StaggeredTiles.module.css";

const StaggeredTiles = ({ props }) => {
  const { headline, tiles } = props;

  const StaggeredTile = ({ props, aosOffset }) => {
    const {
      title,

      image,

      body,
      iconName,
      iconSource,
    } = props;

    const { body: bodyCopy } = body ?? "";

    const imageFile = image && getImage(image.file);

    const iconProps = {
      name: iconName,
      size: "2x",
      isBrand: iconSource === "fab" ? true : false,
      isRegular: iconSource === "far" ? true : false,
      isSolid: iconSource === "fas" ? true : false,
    };

    return (
      <div className={`${staggeredTilesStyles.tileWrapper}`}>
        <div
          /* data-aos="fade-up"
        data-aos-offset={aosOffset} */
          className={`${staggeredTilesStyles.tileContainer}`}
        >
          <div className={`${staggeredTilesStyles.tileItem}`}>
            <div>
              <div className={staggeredTilesStyles.icon}>
                <Icon props={iconProps} />
              </div>
              <h5 className={staggeredTilesStyles.title}>{title}</h5>
              <p className={staggeredTilesStyles.text}>{bodyCopy}</p>
            </div>
            <div className={staggeredTilesStyles.imageBg}>
              {/* <div className={staggeredTilesStyles.blueOverlay}></div> */}
              <GatsbyImage
                image={imageFile}
                alt={image.alt}
                className={staggeredTilesStyles.image}
              />
            </div>
            {/* <div className={staggeredTilesStyles.backdrop} /> */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={staggeredTilesStyles.tiles}>
      {headline && <h2>{headline}</h2>}
      <div className={`${staggeredTilesStyles.tilesContainer}`}>
        {tiles.map((tile, index) => {
          return (
            <StaggeredTile
              props={tile}
              // aosOffset={(index + 1) * 100}
            />
          );
        })}
      </div>
    </div>
  );
};

export default StaggeredTiles;
